module.exports = " <div class=indicator-line _v-1565a68f=\"\"> <div class=connect-line _v-1565a68f=\"\"> <div class=indicator-line-flex _v-1565a68f=\"\"> <slot _v-1565a68f=\"\"></slot> </div> <div :class=\"['line-basis', line ? 'has-line' : 'no-line']\" _v-1565a68f=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1565a68f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/indicator-cause/indicator-line/index.vue
// module id = 315
// module chunks = 0